export const Captable = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_300_3785)">
      <path
        d="M8.16667 1.75C8.16667 1.428 7.90533 1.16667 7.58333 1.16667H1.75C1.428 1.16667 1.16667 1.428 1.16667 1.75V12.8333H7V14H0V1.75C0 0.785167 0.785167 0 1.75 0H7.58333C8.54817 0 9.33333 0.785167 9.33333 1.75V6.72292C8.62925 7.25608 8.16667 8.092 8.16667 9.04167V1.75ZM4.08333 7.58333H2.33333V8.75H4.08333V7.58333ZM5.25 8.75H7V7.58333H5.25V8.75ZM2.33333 11.0833H4.08333V9.91667H2.33333V11.0833ZM5.25 11.0833H7V9.91667H5.25V11.0833ZM4.08333 2.91667H2.33333V4.08333H4.08333V2.91667ZM5.25 4.08333H7V2.91667H5.25V4.08333ZM4.08333 5.25H2.33333V6.41667H4.08333V5.25ZM5.25 6.41667H7V5.25H5.25V6.41667ZM11.0833 10.5C11.8877 10.5 12.5417 9.84608 12.5417 9.04167C12.5417 8.23725 11.8877 7.58333 11.0833 7.58333C10.2789 7.58333 9.625 8.23725 9.625 9.04167C9.625 9.84608 10.2789 10.5 11.0833 10.5ZM12.25 11.0833H9.91667C8.95183 11.0833 8.16667 11.8685 8.16667 12.8333V14H9.33333V12.8333C9.33333 12.5113 9.59467 12.25 9.91667 12.25H12.25C12.572 12.25 12.8333 12.5113 12.8333 12.8333V14H14V12.8333C14 11.8685 13.2148 11.0833 12.25 11.0833Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_300_3785">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
